import PropTypes from 'prop-types';

import { Box } from '@mui/material';

const InfoComponent = ({ children, isWarning = false }) => (
  <Box
    sx={(theme) => [
      {
        padding: '1.2rem 2rem',
        background: theme.palette.custom.info.background,
        borderRadius: '1rem',
        marginBottom: '1rem',
        color: theme.palette.custom.info.text,
      },
      isWarning && {
        background: theme.palette.custom.warning.background,
        color: theme.palette.custom.warning.text,
      },
    ]}
  >
    {children}
  </Box>
);

InfoComponent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
  ]),
  isWarning: PropTypes.bool,
};

export default InfoComponent;
